//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

declare const chrome: undefined | {
  runtime?: {
    lastError?: {
      message: string;
    }
    sendMessage: (extensionId: string, msg: Record<string, unknown>, callback: (fSuccess: boolean) => void) => void;
  }
};

// TODO: Find a better way to manage this extension ID
// TODO: Create a listener for this message in the curalate chrome extension
const chromeExtensionId = 'fkjdbkkkphijekcehoamjojfbgidlbli';
const CHROME_EXTENSION_MESSAGE_TYPES = {
  IS_ALIVE: 'IS_ALIVE',
};
const NO_RECEIVING_END_ERROR = 'Could not establish connection. Receiving end does not exist.';

export const hasChromeExtension = (respCallback: (fSuccess: boolean) => void) => {
  if (typeof chrome !== 'undefined' && chrome.runtime) {
    chrome.runtime.sendMessage(
      chromeExtensionId,
      {
        type: CHROME_EXTENSION_MESSAGE_TYPES.IS_ALIVE,
      },
      respCallback,
    );
  } else {
    respCallback(false);
  }
};

export const connectionError = () => {
  if (typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.lastError) {
    return chrome.runtime.lastError.message === NO_RECEIVING_END_ERROR;
  }

  return false;
};
